import { useState, useEffect, useRef } from 'react';
import {
  ITimesheetParams,
  ITimesheet,
  IApiPagination,
  IPageInfo,
} from 'interfaces';
import { timesheetServices } from 'services';
import { timesheetConstants } from 'constants/index';
import { fileService } from 'services';

const useTimesheet = (defaultParams: ITimesheetParams) => {
  const didMount = useRef(true);
  const [loadingTimesheet, setLoadingTimesheet] = useState(false);
  const [pageInfo, setPageInfo] = useState<IPageInfo>(
    timesheetConstants.DEFAULT_PAGE
  );
  useEffect(() => {
    if (didMount.current) {
      didMount.current = false;
      return;
    }
    getTimesheet();
  }, [pageInfo]);
  const [timesheet, setTimesheet] = useState<ITimesheet[]>([]);
  const [params, setParams] = useState<ITimesheetParams>(defaultParams);
  const [pagerApi, setPagerApi] = useState<IApiPagination>(
    timesheetConstants.DEFAULT_PAGINATION
  );

  const getTimesheet = async () => {
    setLoadingTimesheet(true);
    try {
      const result = await timesheetServices.getTimesheet(params);
      if (result) {
        const { items, pagination } = result;
        setTimesheet(items);
        setPagerApi(pagination);
      }
    } finally {
      setLoadingTimesheet(false);
    }
  };

  const exportExcel = async () => {
    try {
      const result = await timesheetServices.exportTimesheet(params);
      if (result) {
        const { filePath } = result;
        fileService.downloadFileToDevice(filePath, filePath);
      }
    } finally {
    }
  };
  const reject = async (id: number, reasonReject: string) => {
    try {
      await timesheetServices.rejectTimesheet(id, reasonReject);
      await getTimesheet();
    } finally {
    }
  };
  return {
    timesheet,
    params,
    setParams,
    getTimesheet,
    exportExcel,
    pagerApi,
    reject,
    setPageInfo,
    loadingTimesheet,
  };
};

export default {
  useTimesheet,
};
